export const ABOUT_TEXT = `This is a beta test environment of EY-Parthenon GmbH.
For further questions, please contact jan.sauerbrey@parthenon.ey.com <br>
<br>
Please see the Help for more detailed instructions.`


export const MAIN_MODULE_NAME = 'main.module'
